export default {
      id: "LWS-8px-usage",
      viewBox: "0 0 60 8",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-8px",
      toString: function () {
        return this.url;
      }
    }